import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';
import AnimeCard from '@/components/base/AnimeCard';

export function FeaturedSection() {
  const featured = animeList.filter((a) => a.featured);
  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">热门推荐</h2>
        </div>
        <p className="mt-2 text-sm text-foreground-500">编辑精选，口碑爆棚的高分佳作，点击直达动漫网入口。</p>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((item) => (
            <AnimeCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

export function LatestSection() {
  const latest = animeList.slice(0, 6);
  return (
    <section className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <p className="text-sm font-medium text-accent-600">NEW ARRIVALS</p>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">最近更新</h2>
        </div>
        <Link to="/category" className="flex items-center gap-1 text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap">
          更多番剧 <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((item) => (
          <AnimeCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}